<template>
  <app-admin>

    <div class="container content">
      <loader ref="loader"/>

      <h1>Участники онлайн</h1>

      <app-search @change="handleFilter"></app-search>

      <table cellspacing="0" cellpadding="0" class="main-table">
        <thead>
        <tr>
          <th class="index">№</th>
          <th class="fio">ФИО участника</th>
          <th>Время начала</th>
          <th>Программа</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="filteredResults.length == 0">
          <td colspan="4" class="text-center"><em>Участников не найдено</em></td>
        </tr>
        <tr v-for="(result, index) in filteredResults" :key="result.id">
          <td>{{index + 1}}</td>
          <router-link :to="{ name: 'Player', params: { id: result.player.id }}" tag="td" class="hover">
            {{result.player.last_name}} {{result.player.first_name}} {{result.player.middle_name}}
          </router-link>
          <td>{{result.date_started | date('HH:mm')}}</td>
          <td>{{result.test.name}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </app-admin>
</template>

<script>
  import PlayersService from '@/services/PlayersService'

  export default {
    name: 'players-online',
    data () {
      return {
        filter: '',
        results: [],
        filteredResults: []
      }
    },
    methods: {
      handleFilter: function (filter) {
        this.filter = filter
        this.filteredResults = this.results.filter((result) => {
          let fio = result.player.last_name + ' ' + result.player.first_name + ' ' + result.player.middle_name
          return fio.toLowerCase().includes(filter.toLowerCase())
        })
      },
      getPlayersOnline () {
        this.$refs.loader.show()
        PlayersService.getPlayersOnline().then(
          (response) => {
            this.results = response
            this.filteredResults = response
            this.$refs.loader.hide()
          }
        )
      }
    },
    mounted () {
      this.getPlayersOnline()
    }
  }
</script>

<style scoped lang="scss">
  table {
    tr td:nth-child(4) {
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/players-online/PlayersOnline.vue